/**
 * Created by suhel on 4/26/17.
 */
import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { inject, observer } from 'mobx-react';
import { observable, toJS, action, autorun } from 'mobx';
// import HierTable from '../HierTable';
import * as api from '../../actions/api';
import { token } from "../../libs/localStorage";
import Modal from '../Modal';

@inject('rolePermissionStore', 'uiStore')
@observer
export default class RolePermissionList extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  @observable data = [];
  @observable allPermissions = token.getPermissions();
  @observable resources = [];
  @observable rowCheckBox = [];
  @observable headerCheck = false;
  dispose;

  componentWillMount() {
    const { rolePermissionStore, role } = this.props;
    this.dispose = autorun(() => {
      this.makeRequest(role.id);
      this.flattenPermissions(rolePermissionStore.items);
    });
  }

  componentWillReceiveProps(nextProps) {
    this.makeRequest(nextProps.role.id);
  }

  flattenPermissions = allpermissions => {
    let uniqueResources = [];
    let uniqueRowCheckBox = [];
    allpermissions.map(perm => {
      let res = uniqueResources.filter(res => res.resource == perm.resource);
      if (res.length === 0) {
        uniqueRowCheckBox.push({
          resource: perm.resource,
          checked: false
        });
        uniqueResources.push({
          resource: perm.resource,
          actions: [{
            type: 'view',
            access: false
          }, {
            type: 'modify',
            access: false
          }]
        });
      }
    });
    this.rowCheckBox = uniqueRowCheckBox;
    this.resources = uniqueResources;
  };

  @action setCheckboxSelected = (res) => {
    this.resources.map(res => [
      res.actions.map(action => {
        action.access = false;
      })
    ]);
    res.map(perm => {
      let permission = perm.permission.split(' '),
        resource = permission[1],
        action = permission[0];
      this.resources.filter(res => res.resource == resource)[0]
        .actions.filter(act => act.type == action)[0].access = true;
    })
  };

  makeRequest = async (id) => {
    const res = await api.userPermission.crudAccess.fetchById(id);
    this.setCheckboxSelected(await res);
  };

  @action onChangeCheck(resource, action) {
    this.resources.filter(res => res.resource == resource)[0]
      .actions.filter(act => act.type == action)[0]
      .access ^= true;
  }

  handleSaveUserPermission = () => {
    const { role: { id }, closeModal } = this.props;
    const { notify } = this.context;

    let json = [];

    this.resources.map(res => {
      res.actions.map(action => {
        if (action.access) {
          json.push({
            role_id: id,
            permission: `${action.type} ${res.resource}`
          })
        }
      })
    });

    api.userPermission.crudAccess.create({
      role_id: id,
      permissions: json
    }).then(res => {
      notify.success(res);
      if (+id === +token.getDecoded().id) {
        let permissionArray = json.map(perm => perm.permission);
        token.setPermissions(permissionArray);
      }
      closeModal();
    }).catch(notify.error);
  };

  @action onDeleteRole = (resource) => {
    const { notify } = this.context;
    /*global event, fdescribe*/
    /*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
    if (confirm('Delete Role?')) {
      this.props.rolePermissionStore.deleteRolePermission(resource)
        .then(notify.success)
        .catch(notify.error);
    }
  };

  @action onCheckHeader = (e) => {
    this.headerCheck ^= true;
    this.resources.map(res => {
      res.actions.map(act => {
        act.access = this.headerCheck;
      })
    });
    this.rowCheckBox.map(row => { row.checked = this.headerCheck });
  };
  @action onCheckRow = (resource) => {
    this.rowCheckBox.filter(row => row.resource == resource)[0].checked ^= true;
    this.resources.filter(res => res.resource == resource)[0]
      .actions.map(action => {
        action.access = this.rowCheckBox.filter(row => row.resource == resource)[0].checked;
      })
  };

  render() {
    const { role: { name }, rolePermissionStore, uiStore, closeModal } = this.props;
    let modifyPermission = rolePermissionStore.validateRole('modify permission')
    
    return (
      <Modal title={`Role Permissions - ${name}`} closeModal={closeModal} handleSave={this.handleSaveUserPermission}>
        <div className="DataTable" style={{ width: uiStore.mobileView ? '90vw' : '60vw' }}>
          <table>
            <thead>
              <tr>
                <th><input type="checkbox" disabled={!modifyPermission} value={this.headerCheck} onChange={this.onCheckHeader} /></th>
                <th>Role</th>
                <th>View</th>
                <th>Modify</th>
                {modifyPermission && <th className="crudActions">
                  <Link to={`role/permission-add`}>
                    <i className="fa fa-plus white" aria-hidden="true" />
                  </Link>
                </th>}
              </tr>
            </thead>
            <tbody>
              {this.resources.map((res, index) => {
                return (
                  <tr key={index}>
                    <td><input type="checkbox" disabled={!modifyPermission} checked={this.rowCheckBox.filter(row => row.resource == res.resource)[0].checked} onChange={this.onCheckRow.bind(this, res.resource)} /></td>
                    <td>{res.resource}</td>
                    {res.actions.map((action, tdIndex) => (
                      <td key={tdIndex}><input type="checkbox" disabled={!modifyPermission} checked={action.access} value={action.access}
                        onChange={this.onChangeCheck.bind(this, res.resource, action.type)} /></td>
                    ))}
                    {modifyPermission && <td className="crudActions">
                      <a onClick={this.onDeleteRole.bind(this, res.resource)}>
                        <i className="fa fa-trash" aria-hidden="true" />
                      </a>
                    </td>}
                  </tr>
                )
              })}
            </tbody>
          </table>
          {modifyPermission && <button className="button" onClick={this.handleSaveUserPermission}>Save</button>}
        </div>
      </Modal>

    )
  };

}


// WEBPACK FOOTER //
// ./src/components/Permission/RolePermissionList.js